import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Celebration } from "../../../uiKit/assets/svg/celebration.js";
import AnonymousThankYou from "../../UnauthorizedPages/thankyou.js";
import CustomButton from "../../../uiKit/Button/CustomButton.js";
import Title from "../../../uiKit/Title/Title.js";
import { gray800 } from "../../../uiKit/assets/colors/colors.js";

import { setAutoDonateOpen } from "../../../redux/state/donationSlice.js";

const CampaignThankYou = ({ onClose }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const id = useSelector((state) => state.account.userDetails?.id, shallowEqual);
  const savedCard = useSelector((state) => state.payment.savedCard);

  const learnMoreHandler = () => {
    onClose();
    dispatch(setAutoDonateOpen(true));
  };

  const navigateToPaymentPreferences = () => {
    history.push("/payment-preferences");
  };

  if (!id) return <AnonymousThankYou onClose={onClose} />;
  return (
    <div className="createdPage" style={{ padding: "32px" }}>
      <div className="feedback">
        <div className="feedbackContainer">
          <div className="feedbackImageContainer">
            <Celebration />
          </div>
          <div className="description">
            <Title
              text="Thank you"
              fontSize={24}
              lineHeight={32}
              style={{ marginBottom: "16px" }}
            />
            <div style={{ marginBottom: "16px" }}>
              <Title text={"You have helped your community."} fontWeight={400} />
              <Title text={"Be proud."} fontWeight={400} />
            </div>
          </div>
          <div className="autoDonateInfo">
            <Title text="NEW!" color={gray800} />
            <div className="annoncement">
              We're launching a new <span>'Auto-donate'</span> feature, where you can support all
              new campaigns automatically. Once a new campaign is launched, you'll be charged the
              amount you've subscribed to.
            </div>
            {!!savedCard?.id ? (
              <CustomButton title={"Learn More"} onClick={learnMoreHandler} />
            ) : (
              <div
                style={{ marginTop: "8px", cursor: "pointer" }}
                onClick={navigateToPaymentPreferences}
              >
                <Title text={"Account does not have a saved card."} fontWeight={400} />
                <Title text={"Add one to enable auto-donate."} fontWeight={400} />
              </div>
            )}
          </div>
        </div>
        <div style={{ marginTop: "24px", width: "100%" }}>
          <CustomButton onClick={onClose} title={"Back to campaigns"} isWhite={true} />
        </div>
      </div>
    </div>
  );
};

export default CampaignThankYou;
